// Mot de passe oublié (R-AUTH-04) et réinitialisation par lien (R-AUTH-05, R-AUTH-06).
import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { api, ErreurApi } from '../api';
import { magasin } from '../donnees/magasin';

export function MotDePasseOublie() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState<string>();
  const [enCours, setEnCours] = useState(false);

  async function soumettre(e: FormEvent) {
    e.preventDefault();
    setEnCours(true);
    try {
      const r = await api<{ message: string }>('/api/auth/mot-de-passe-oublie', { corps: { email: email.trim() } });
      setMessage(r.message);
    } catch (err) {
      setMessage(err instanceof ErreurApi ? err.message : 'Pas de réseau : réessaie quand tu seras connecté.');
    } finally {
      setEnCours(false);
    }
  }

  return (
    <div className="connexion-page">
      <form className="carte" onSubmit={soumettre}>
        <h1>Mot de passe oublié</h1>
        <p className="doux">Tu recevras un lien valable 30 minutes, utilisable une seule fois.</p>
        {message ? <div className="message info">{message}</div> : null}
        <div className="champ">
          <label htmlFor="email">Email</label>
          <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <button className="principal" type="submit" disabled={enCours}>Envoyer le lien</button>
        <p className="petit-texte" style={{ marginTop: '1em' }}><Link to="/connexion">Retour à la connexion</Link></p>
      </form>
    </div>
  );
}

export function Reinitialiser() {
  const [params] = useSearchParams();
  const jeton = params.get('jeton') ?? '';
  const naviguer = useNavigate();
  const [motDePasse, setMotDePasse] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [erreur, setErreur] = useState<string>();
  const [enCours, setEnCours] = useState(false);

  async function soumettre(e: FormEvent) {
    e.preventDefault();
    setErreur(undefined);
    if (motDePasse !== confirmation) { setErreur('Les deux mots de passe ne sont pas identiques.'); return; }
    setEnCours(true);
    try {
      await api('/api/auth/reinitialiser', { corps: { jeton, mot_de_passe: motDePasse } });
      await magasin.verifierSession();
      naviguer('/', { replace: true });
    } catch (err) {
      setErreur(err instanceof ErreurApi ? err.message : 'Pas de réseau : réessaie quand tu seras connecté.');
    } finally {
      setEnCours(false);
    }
  }

  if (!jeton) return <div className="connexion-page"><div className="carte"><h1>Lien incomplet</h1><p>Ouvre le lien reçu par email en entier, ou <Link to="/mot-de-passe-oublie">demande un nouveau lien</Link>.</p></div></div>;

  return (
    <div className="connexion-page">
      <form className="carte" onSubmit={soumettre}>
        <h1>Nouveau mot de passe</h1>
        {erreur ? <div className="message erreur" role="alert">{erreur} {erreur.includes('plus valable') ? <Link to="/mot-de-passe-oublie">Demander un nouveau lien</Link> : null}</div> : null}
        <div className="champ">
          <label htmlFor="mdp">Nouveau mot de passe (12 caractères minimum)</label>
          <input id="mdp" type="password" autoComplete="new-password" minLength={12} required value={motDePasse} onChange={(e) => setMotDePasse(e.target.value)} />
        </div>
        <div className="champ">
          <label htmlFor="conf">Confirme le mot de passe</label>
          <input id="conf" type="password" autoComplete="new-password" required value={confirmation} onChange={(e) => setConfirmation(e.target.value)} />
        </div>
        <button className="principal" type="submit" disabled={enCours}>Changer le mot de passe</button>
      </form>
    </div>
  );
}
